import React from 'react'
import { makeStyles } from '@material-ui/core/styles';

const UseStyles = makeStyles((theme) => ({
        root: {
          width: '100%',
        },
        backButton: {
          marginRight: theme.spacing(1),
        },
        instructions: {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
        },
        errors: {
          color: "red",
          fontHeight: "bold",
        },
        formControlComponent: {
          margin: 10,
          minWidth: 350,
      
        },
        horasComponent: {
          margin: 10,
          minWidth: 350,
          width: '85%'
        },
        nextArrow: {
          marginRight: 50
        },
        backArrow: {
          marginLeft: 50
        },
        formControlComponentFinal: {
          margin: 5,
          minWidth: 250
        },
        contenedorForm: {
          background: 'white',
          marginTop: '10px',
          borderRadius: '5px',
          maxWidth: '70%',
          width: '800px',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginBottom: '160px',
          marginTop: '60px'
        }
      
      }));
      

export default UseStyles